import { sound } from '@pixi/sound';
import { Buildings } from '~/utils/constants';

export default defineNuxtPlugin(async () => {
  const store = useMainStore();
  const { openedBuilding, volume } = toRefs(store);

  sound.add(Buildings.GoldOreSmelter, '/sound/modalsBgSounds/GoldOreSmelter_1.mp3');
  sound.add(Buildings.Jewelry, '/sound/modalsBgSounds/Jevelry_1.mp3');
  sound.add(Buildings.Dock, '/sound/modalsBgSounds/Dock_1.mp3');
  sound.add(Buildings.BlackSmith, '/sound/modalsBgSounds/Blacksmith_1.mp3');
  sound.add(Buildings.Sawmill, '/sound/modalsBgSounds/Sawmill_1.mp3');
  sound.add(Buildings.ToymakerShop, '/sound/modalsBgSounds/Toymaker1.mp3');
  sound.add(Buildings.Plantation, '/sound/modalsBgSounds/Plantation_1.mp3');
  sound.add(Buildings.Warehouse, '/sound/modalsBgSounds/Storage_1.mp3');
  sound.add(Buildings.Townhall, '/sound/modalsBgSounds/Townhall_1.mp3');
  sound.add(Buildings.IronOreMine, '/sound/modalsBgSounds/IronQwarry_1.mp3');
  sound.add(Buildings.CoalMine, '/sound/modalsBgSounds/CoalMine_1.mp3');
  sound.add(Buildings.GoldOreMine, '/sound/modalsBgSounds/GoldOreMine_1.mp3');
  sound.add(Buildings.IronOreSmelter, '/sound/modalsBgSounds/IronOreSmelter_1.mp3');
  sound.add(Buildings.Tavern, '/sound/modalsBgSounds/Taverna1.mp3');
  sound.add(Buildings.Barbershop, '/sound/modalsBgSounds/barbershop_1.mp3');
  sound.add(Buildings.CeramicWorkshop, '/sound/modalsBgSounds/CeramicWorkshop_1.mp3');
  sound.add(Buildings.GlassWorkshop, '/sound/modalsBgSounds/GlassWorkshop_1.mp3');
  sound.add(Buildings.ClayQuarry, '/sound/modalsBgSounds/ClayQwarry_1.mp3');
  sound.add(Buildings.SandQuarry, '/sound/modalsBgSounds/SandQwarry_1.mp3');
  sound.add(Buildings.Seller, '/sound/modalsBgSounds/MercchantShop_1.mp3');
  sound.add(Buildings.ConstructionCamp, '/sound/modalsBgSounds/BuildersCamp_1.mp3');
  sound.add(Buildings.Dex, '/sound/modalsBgSounds/dex.mp3');
  sound.add(Buildings.Manor, '/sound/modalsBgSounds/Jevelry_1.mp3');

  sound.add(Buildings.WitchHut, '/sound/modalsBgSounds/WitchHouse_02bublez.mp3');
  sound.add(Buildings.Cave, '/sound/modalsBgSounds/CaveAmbient.mp3');
  sound.add(Buildings.Forest, '/sound/modalsBgSounds/ForestAmbient.mp3');

  watch(openedBuilding, (soundName, oldName) => {
    if (oldName) {
      sound.find(oldName)?.stop();
    }

    if (!soundName) return;

    const audioItem = sound.find(soundName);
    if (!audioItem) return;

    audioItem.loop = true;
    audioItem.volume = volume.value.ambient;
    audioItem.play();
  });

  watch(
    volume,
    (newVolume) => {
      if (!openedBuilding.value) return;
      const audioItem = sound.find(openedBuilding.value);
      audioItem.volume = newVolume.ambient;
    },
    { deep: true }
  );
});
